/**
 * Who you are dealing with, by ONDO id — OND-81.
 *
 * One read. A 403 covers "no such id" and "not somebody you are dealing with"
 * alike, in the sentence the server gives; a 429 is a spent guessing budget
 * and is not a verdict about the id, which `describeApiError` keeps as the
 * server's own words. There is no search and no list: the id comes off the row
 * that named them.
 */
import type { CounterpartyProfileResponse } from "@ondo/shared";

import { request } from "./request.ts";

export const fetchCounterpartyProfile = (ondoId: string) =>
  request<CounterpartyProfileResponse>(`/principals/${encodeURIComponent(ondoId)}/profile`);
